module.exports = __webpack_public_path__ + "static/media/benefit-anxiety.084fd202.svg";